import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-c8c676a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "actualite-area gray-bg section-padding pt-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Chargement des vidéos…", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "row actualite-item-wrap"
}
const _hoisted_8 = { class: "row justify-content-center g-3" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "media-box" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "video-title" }
const _hoisted_13 = { class: "mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col-3 mb-5",
                key: item.id
              }, [
                _createElementVNode("div", _hoisted_8, [
                  (item.source && _ctx.isYoutubeUrl(item.source))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("iframe", {
                            src: _ctx.getYoutubeEmbedUrl(item.source),
                            class: "media-frame",
                            allowfullscreen: ""
                          }, null, 8, _hoisted_11)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(item.titre), 1)
                ])
              ]))
            }), 128))
          ])),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}